import React from 'react';
import { SnapSelectMenu, SnapSelectMenuOptionType } from './SnapSelectMenu';

export interface SelectorOption {
  value: string;
  displayName?: string;
  selected?: boolean;
}

export default function RawSelector({
  label,
  options,
  onChange,
}: {
  label: string;
  options: SelectorOption[];
  onChange: (value: string) => void;
}): JSX.Element {
  if (options.some((o) => !o.displayName)) {
    throw new Error(`1 or more options is missing displayName`);
  }
  const selectOptions: SnapSelectMenuOptionType[] = options.map((o, index) => ({
    id: index,
    name: o.displayName!,
    value: o.value,
    selected: o.selected === true,
    label: o.displayName,
    type: 'option',
  }));

  const onSelect = (option?: SnapSelectMenuOptionType | null): void => {
    if (option?.value === undefined || option?.value === null) {
      return;
    }
    onChange(option.value);
  };

  return (
    <div>
      <div
        className='w-full'
        style={{
          display: 'inline-flex',
          verticalAlign: 'bottom',
        }}
      >
        <SnapSelectMenu
          label={label}
          mobileFullHeight
          selectOptions={selectOptions}
          onSelect={onSelect}
          mobileHeader={label}
        />
      </div>
    </div>
  );
}
